import { UseFormSetValue } from "react-hook-form"
import { ModalidadGrupoTarifa, Reserva, TiposAlojamientos } from "src/gql/schema"
import { DefaultValuesType } from "../VentaHabitacion.types"

const useSetFormStateFromReserva = ({
    setValue
}: {
    setValue: UseFormSetValue<DefaultValuesType>,
}) => {

    const setFormState = ({reserva, tarifas}: {reserva?: Reserva, tarifas: any[]}) => {
        if (!reserva || tarifas.length === 0) {
            return
        }

        const base_ids:string[] = []
        const temp_ids:string[] = []
        const adicionales_ids:string[] = []

        const find_tarifa_reserva_base = tarifas?.filter((i)=>i?.tipo_tarifa === "reserva" && i?.tipo_alojamiento === "hotel" && i?.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base) || []
        const tarifa_reserva_base = find_tarifa_reserva_base?.map((t)=>t.tarifa_id)

        reserva?.reservas_tarifas?.forEach((i)=>{
            const tarifa_id = i?.tarifa?.tarifa_id || ""
            const modalidad = i?.tarifa?.grupo_tarifa?.modalidad || ""

            if (modalidad === "base") {
                base_ids.push(tarifa_id)
            }

            if (modalidad === "temporada") {
                temp_ids.push(tarifa_id)
            }

            if (modalidad === "adicional") {
                adicionales_ids.push(tarifa_id)
            }
        })

        const tarifas_base_id = base_ids.length > 0 ? base_ids : tarifa_reserva_base
        const tarifas_ids = [... new Set([...tarifas_base_id, ...temp_ids])]
        const tarifas_adicionales_ids = [... new Set([...adicionales_ids])]

        setValue("type", reserva?.tarifa?.tipo_alojamiento || TiposAlojamientos.Hotel)
        setValue("tarifas", tarifas_ids)

        if (tarifas_adicionales_ids.length > 0) setValue("tarifas_adicionales", tarifas_adicionales_ids)
    }

    return [setFormState]
}

export default useSetFormStateFromReserva
